// i18n ignore
import { memoize } from 'lodash';
import { globalConstantService } from '@/workbench/modules/services/global-constant';
import { getDataSchemaType } from '@utils/data-schema-helper';
import { getGlobalConstantSchema } from '@/utils/global/api-schema';
/**
 * 获取全局常量类型定义
 */
const getGlobalConstantDts = memoize(async (projectId) => {
    if (window.w?.mode !== 'editor' || !projectId)
        return '';
    const constList = await globalConstantService.list(projectId);
    const frontConstantList = constList.filter(item => !item.onlyBackend);
    if (!frontConstantList.length)
        return '';
    const schema = getGlobalConstantSchema(frontConstantList);
    const dts = getDataSchemaType(schema, { dept: 1, forceFieldsRequired: true });
    return dts.trim();
});
/**
 * 全局常量 DTS 注入器
 */
export const globalConstantInjector = {
    placeholder: '/** inject-global-constant-dts */',
    async generate(projectId) {
        const typeDts = await getGlobalConstantDts(projectId);
        if (!typeDts)
            return '';
        return `
  /**
   * 当前全局常量实例
   * @usage import { getGlobal } from '@wujibase/wuji';
   */
  export function getGlobal(): ${typeDts}`;
    },
};
